var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],attrs:{"aria-hidden":!_vm.active,"role":"tabpanel"}},[_vm._t("default",null,{"active":_vm.active})],2)}
var staticRenderFns = []

export { render, staticRenderFns }